import { Column } from 'react-table';

import { DataSourcesTableItem, useDataSourcesTableColumns } from '@neo.tax/shared';

/**
 * On ASC, costs and payroll-month expenses are uploads the customer deletes; everything else in
 * these tables is a connection they disconnect.
 */
const ASC_DELETABLE_ITEM_TYPES: ReadonlySet<DataSourcesTableItem['itemType']> = new Set([
  'payroll-month-expense',
  'asc-cost',
]);

export const useAscDataSourcesTableColumns = (
  options: Omit<Parameters<typeof useDataSourcesTableColumns>[0], 'deletableItemTypes'>,
): Column<DataSourcesTableItem>[] =>
  useDataSourcesTableColumns({ ...options, deletableItemTypes: ASC_DELETABLE_ITEM_TYPES });
